var map = {
	"./DrLubhani/ChangeColor": [
		798,
		179
	],
	"./Ganga/ChangeColor": [
		800,
		185
	],
	"./Indus/ChangeColor": [
		802,
		198
	],
	"./Kabini/ChangeColor": [
		804,
		205
	],
	"./Kaveri/ChangeColor": [
		716,
		21
	],
	"./Luni/ChangeColor": [
		806,
		211
	],
	"./Narmada/ChangeColor": [
		808,
		214
	],
	"./Neyyar/ChangeColor": [
		810,
		221
	],
	"./Periyar/ChangeColor": [
		812,
		224
	],
	"./SAANVI/ChangeColor": [
		814,
		234
	],
	"./Sabarmathi/ChangeColor": [
		816,
		241
	],
	"./Sparsh/ChangeColor": [
		818,
		247
	],
	"./Sutlej/ChangeColor": [
		820,
		251
	],
	"./Yamuna/ChangeColor": [
		822,
		257
	],
	"./pamba/ChangeColor": [
		824,
		266
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2065;
module.exports = webpackAsyncContext;